export default __webpack_public_path__ + "static/2-toolkit-a61400dbb516df6660dce1c8c3218c84.png";